"use client";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import { observer, useStore } from "../../service/mobx";

const Stack = dynamic(() => import("@mui/material/Stack"));
const Slide = dynamic(() => import("@mui/material/Slide"));
const Typography = dynamic(() => import("@mui/material/Typography"));
const Button = dynamic(() => import("@mui/material/Button"));

function AdBanner() {
  const [show, setShow] = useState(true);
  const [renderBanner, setRenderBanner] = useState(false);
  const { analytics, layout, reader } = useStore();

  useEffect(() => {
    if (layout.checkedWhiteLabel && reader.whiteLabelled === false) {
      const consent = localStorage.getItem("eu_ad_consent");

      window.uetq ??= [];

      if (consent === null) {
        fetch("https://ipapi.co/json/").then(async res => {
          if (res.ok) {
            var { in_eu } = await res.json();
          }

          const inTheEU =
            in_eu ||
            Intl.DateTimeFormat()
              .resolvedOptions()
              .timeZone.startsWith("Europe/");

          if (inTheEU) {
            setRenderBanner(true);
          } else {
            // If they're not in the EU, we can assume consent and load the scripts immediately
            window.uetq.push("consent", "update", { ad_storage: "granted" });
            localStorage.setItem("eu_ad_consent", "1");
          }
        });
      } else if (consent === "1") {
        window.uetq.push("consent", "update", { ad_storage: "granted" });
      }
    }
  }, [analytics, layout.checkedWhiteLabel, reader.whiteLabelled]);

  return renderBanner ? (
    <Slide direction="up" in={show} mountOnEnter unmountOnExit>
      <Stack
        spacing={5}
        p={2}
        direction="row"
        alignItems="center"
        justifyContent="center"
        width="100%"
        position="fixed"
        bottom={0}
        left={0}
        zIndex={999990}
        height={80}
        boxShadow="var(--elevation-4)"
        bgcolor="var(--surface-container-highest)"
      >
        <Typography variant="titleLg">
          We use cookies to measure A/B tests and ads
        </Typography>
        <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={() => {
            // Hide the banner
            setShow(false);

            window.uetq.push("consent", "update", { ad_storage: "granted" });
            // Save their choice to local storage
            localStorage.setItem("eu_ad_consent", "1");
          }}
        >
          Allow
        </Button>
        <Button
          size="large"
          variant="outlined"
          color="primary"
          onClick={() => {
            // Hide the banner
            setShow(false);

            window.uetq.push("consent", "update", { ad_storage: "denied" });
            // Save their choice to local storage
            localStorage.setItem("eu_ad_consent", "0");
          }}
        >
          Reject
        </Button>
      </Stack>
    </Slide>
  ) : null;
}

export default observer(AdBanner);
